// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.financial-target-form-dialog-body {
    border-top: 1px solid rgb(225, 225, 225);
    border-bottom: 1px solid rgb(225, 225, 225);
    min-height: 400px;
    padding: 24px;
    display: flex;
}

.financial-target-form-dialog-container {
    min-width: 600px;
    max-width: 1024px;
    padding: 0;
}

.financial-target-form-button.primary {
    background-color: #00a9a4;
}

.financial-target-form-button:disabled {
    background-color: #e1e1e1;
}

.financial-target-form-button {
    border-radius: 24px;
}

.financial-target-form-dialog-footer {
    display: flex;
    flex-direction: row;
    padding-top: 20px;
    justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./client/components/product-collection/footer/components/financial-target-form/financial-target-form.css"],"names":[],"mappings":"AAAA;IACI,wCAAwC;IACxC,2CAA2C;IAC3C,iBAAiB;IACjB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;AAC7B","sourcesContent":[".financial-target-form-dialog-body {\n    border-top: 1px solid rgb(225, 225, 225);\n    border-bottom: 1px solid rgb(225, 225, 225);\n    min-height: 400px;\n    padding: 24px;\n    display: flex;\n}\n\n.financial-target-form-dialog-container {\n    min-width: 600px;\n    max-width: 1024px;\n    padding: 0;\n}\n\n.financial-target-form-button.primary {\n    background-color: #00a9a4;\n}\n\n.financial-target-form-button:disabled {\n    background-color: #e1e1e1;\n}\n\n.financial-target-form-button {\n    border-radius: 24px;\n}\n\n.financial-target-form-dialog-footer {\n    display: flex;\n    flex-direction: row;\n    padding-top: 20px;\n    justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
